import React, { FC } from 'react';
import styled from 'styled-components';
import { Headline4, Headline6 } from '../../Text';
import { Colors } from '../../../../styles/colors';

const FormWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  
  background: ${Colors.white};
  padding: 1rem 1.5rem;
  
  ${Headline4} {
    grid-column: span 2;
    margin-bottom: 3.5rem;
  }
  
  ${Headline6} {
    grid-column: span 2;
    margin-bottom: 2rem;
  }
  
  ${Headline6} {
    grid-column: span 2;
    margin-bottom: 2rem;
  }
`;

interface Props {
  title?: string;
}
export const QuestionnaireForm: FC<Props> = ({ title, ...props }) => {
  return (
    <FormWrapper>
      {
        title &&
        <Headline4>{ title }</Headline4>
      }
      {
        props.children
      }
    </FormWrapper>
  )
}
